import { Component, EventEmitter, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { DialogTemplate } from '@core/models/models';
import { ScreenTitleConfigService } from '@core/services/apis/screen-title-config.service';
import { DummyService } from '@core/services/apis/dummy.service';
import { TOOLTIP_DIALOG } from '@core/constants';

@Component({
  selector: 'caremoni-tag-info-dialog',
  templateUrl: './tag-info-dialog.component.html',
  styleUrls: ['./tag-info-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class TagInfoDialogComponent implements OnInit {
  @Output() onClosedHandler = new EventEmitter();
  @Output() onSavedAnswerDialog =new EventEmitter<any>();

  dialogTemplate: DialogTemplate = new DialogTemplate();

  TT_30 = TOOLTIP_DIALOG.TT_30
  TT_31 = TOOLTIP_DIALOG.TT_31

  constructor(
    public config: DynamicDialogConfig,
    public screenTitleConfigService:ScreenTitleConfigService,
    public dummyService: DummyService,
  ) {}

  async ngOnInit(): Promise<void> {
    this.dialogTemplate.header = "タグ情報とは？";
    this.dialogTemplate.hasFooter = true;
  }
 
  closeModal(){ 
    this.onClosedHandler.emit();
   }
}
